<template functional>
    <form-group :label="props.label" :help="props.help"
                :class="[data.staticClass, {'error' : props.v ? props.v.$error : null}]">
        <div class="input-group">
            <div class="input-group-text" v-if="props.prepend">
                {{ props.prepend }}
            </div>
            <div class="input-group-text pe-0" v-if="!!$slots.prepend">
                <slot name="prepend"></slot>
            </div>
            <input :type="props.type ? props.type: 'text'"
                   class="form-control"
                   :class="[props.inputClass, $slots.prepend ? 'border-start-0' : '']"
                   :placeholder="props.placeholder"
                   :value="props.value"
                   :disabled="props.disabled"
                   :readonly="props.readonly"
                   v-on:input="($event) => {
                       listeners.input && listeners.input($event.target.value);
                       if(props.v){
                           props.v.$touch();
                       }
                       listeners.changed && listeners.changed(true);
                   }"
                   v-on:keyup="listeners.keyup && listeners.keyup($event)"
                   v-on:keypress="listeners.keypress && listeners.keypress($event)"
                   v-on:keydown="listeners.keydown && listeners.keydown($event)"
            >
            <div class="input-group-text" v-if="props.append">
                {{ props.append }}
            </div>
            <div class="input-group-text" v-else-if="!!$slots.append">
                <slot name="append"></slot>
            </div>
        </div>
    </form-group>
</template>

<script>
export default {
    name: 'FormInput',
};
</script>
